'use strict';

export default {
  searchInput: {
    placeholder: 'Search...',
  },
};
